import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { i18n } from "../../translate/i18n";

const EditLaneTagModal = ({ open, onClose, laneTag, onSave }) => {
    const [tagName, setTagName] = useState("");

    useEffect(() => {
        if (laneTag) {
            // Check if laneTag is an object (new relational system) or string (legacy)
            if (typeof laneTag === 'object' && laneTag.name) {
                setTagName(laneTag.name);
            } else {
                setTagName(laneTag);
            }
        }
    }, [laneTag]);

    const handleClose = () => {
        onClose();
        setTagName("");
    };

    const handleSave = () => {
        onSave(laneTag, tagName);
        handleClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">
                {i18n.t("tagModal.title.edit")}
            </DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label={i18n.t("tagModal.form.name")}
                    type="text"
                    fullWidth
                    value={tagName}
                    onChange={(e) => setTagName(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    {i18n.t("tagModal.buttons.cancel")}
                </Button>
                <Button onClick={handleSave} color="primary">
                    {i18n.t("tagModal.buttons.ok")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditLaneTagModal;
